import PropTypes from 'prop-types';
import {useCallback, useContext} from 'react';

import {ROLES_NAMES} from '@/src/app/constants/roles';
import PopupContext from '@/src/popup/utils/PopupContext';

import PersonalDetailsWidgetLayout from '../components/PersonalDetailsWidgetLayout';
import {STUDENT_ID_STATUSES} from '../constants/studentIdStatuses';
import EditFullNamePopup from './EditFullNamePopup';
import ReuploadStudentIdPopup from './ReuploadStudentIdPopup';

const PersonalDetailsWidget = ({
  firstName,
  lastName,
  email,
  userType,
  university,
  studentIdStatus,
  studentIdNumber,
  country,
}) => {
  const {openPopup} = useContext(PopupContext);

  const handleEditFullNameClick = useCallback(() => {
    // @ts-ignore
    openPopup({
      popup: <EditFullNamePopup firstName={firstName} lastName={lastName} />,
      options: {withCloseButton: true},
    });
  }, [firstName, lastName]);

  const handleReuploadStudentIdClick = useCallback(() => {
    // @ts-ignore
    openPopup({
      popup: <ReuploadStudentIdPopup />,
      options: {withCloseButton: true},
    });
  }, []);

  return (
    <PersonalDetailsWidgetLayout
      firstName={firstName}
      lastName={lastName}
      email={email}
      onEditFullNameClick={handleEditFullNameClick}
      userType={userType}
      university={university}
      studentIdStatus={studentIdStatus}
      onReuploadStudentIdClick={handleReuploadStudentIdClick}
      studentIdNumber={studentIdNumber}
      country={country}
    />
  );
};

PersonalDetailsWidget.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  userType: PropTypes.oneOf(Object.values(ROLES_NAMES)),
  university: PropTypes.string,
  studentIdStatus: PropTypes.oneOf(Object.values(STUDENT_ID_STATUSES)),
  studentIdNumber: PropTypes.string,
  country: PropTypes.string,
};

export default PersonalDetailsWidget;
